import { IFormWidgetData, IWidgetWithFormData } from "@pageBuilder/typings";
import { FormWidgetBaseRenderer } from "./form-widget-base-renderer";
import { FormFieldRenderer } from "./form-field-renderer";
import { FormScriptRenderer } from "./form-script.renderer";
import { IRenderingCommonContext } from "@commonRendering/types";
import { FormReCaptchaScriptRenderer } from "./form-recaptcha-script.renderer";
import { FormTruCaptchaScriptRenderer } from "./form-trucaptcha-script.renderer";

export class FormWidgetRenderer extends FormWidgetBaseRenderer {

    private readonly recaptchaScriptRenderer: FormReCaptchaScriptRenderer;
    private readonly trucaptchaScriptRenderer: FormTruCaptchaScriptRenderer;
    private readonly widgetScriptRenderer: FormScriptRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);

        this.recaptchaScriptRenderer = new FormReCaptchaScriptRenderer();
        this.trucaptchaScriptRenderer = new FormTruCaptchaScriptRenderer();
        this.widgetScriptRenderer = new FormScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("formWidget");
    }

    protected createForm(): HTMLFormElement {
        const form = super.createBaseForm();
        form.action = "/forms-endpoint";
        return form;
    }

    protected renderFormWidgetInternal(element: HTMLElement, data: IWidgetWithFormData): HTMLElement {
        const renderedElement = super.renderBaseInternal(element, data);
        if (this.renderingCommonContext.data.captchaInfo.captchaProtectionType === "TruCaptcha") {
            this.trucaptchaScriptRenderer.renderCommon(this.renderedDocument);
        } else if (this.renderingCommonContext.data.captchaInfo.captchaProtectionType === "ReCaptcha"){
            this.recaptchaScriptRenderer.renderCommon(this.renderedDocument);
        }
        this.widgetScriptRenderer.renderCommon(this.renderedDocument);
        this.widgetScriptRenderer.renderLocal(element);

        this.renderStyles(element, data);

        return renderedElement;
    }

    protected setFormData(form: HTMLFormElement, data: IWidgetWithFormData): void {
        const formData = data as IFormWidgetData;
        if (formData?.formId) {
            FormFieldRenderer.ensureHidden(form, "id", formData.formId);
        }

        super.setBaseFormData(form, formData);
    }

}
